export default "__VITE_ASSET__CFKMyHaZ__"